import supabase from '../supabase/supabase';
import { normalizeBillingForStorage } from './billingFormat';

export const EMPTY_BILLING = {
  taxID: '',
  phone: '+55 ',
  address: {
    zipcode: '', street: '', number: '', complement: '', neighborhood: '', city: '', state: '',
  },
};

export const profileToBilling = (row) => ({
  taxID: row?.cpf_cnpj || '',
  phone: row?.phone || '+55 ',
  address: {
    zipcode: row?.postal_code || '',
    street: row?.address || '',
    number: row?.address_number || '',
    complement: row?.complement || '',
    neighborhood: row?.neighborhood || '',
    city: row?.city || '',
    state: row?.state || '',
  },
});

export const billingToProfile = (userId, billing) => {
  const normalized = normalizeBillingForStorage(billing);
  return {
    user_id: userId,
    cpf_cnpj: normalized?.taxID || null,
    phone: normalized?.phone || null,
    postal_code: normalized?.address?.zipcode || null,
    address: normalized?.address?.street || null,
    address_number: normalized?.address?.number || null,
    complement: normalized?.address?.complement || null,
    neighborhood: normalized?.address?.neighborhood || null,
    city: normalized?.address?.city || null,
    state: normalized?.address?.state || null,
  };
};

export async function loadBillingProfile(userId) {
  if (!userId) return EMPTY_BILLING;
  const { data, error } = await supabase.from('billing_profiles').select('*').eq('user_id', userId).maybeSingle();
  if (error) throw error;
  return profileToBilling(data);
}

export async function saveBillingProfile(userId, billing) {
  if (!userId) throw new Error('Usuário inválido.');
  const payload = billingToProfile(userId, billing);
  const { error } = await supabase.from('billing_profiles').upsert(payload, { onConflict: 'user_id' });
  if (error) throw error;
  return profileToBilling(payload);
}
